import { ReactNode } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { AppButton } from 'components/AppButton';
import { getTrans } from 'modules/i18n';

interface Props {
  isOpen: boolean;
  title: string;
  subtitle?: string;
  onClose: () => void;
  onConfirm: () => void;
  children?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmColor?: 'primary' | 'error';
}

export const AlertDialog = ({
  isOpen,
  title,
  subtitle,
  onClose,
  onConfirm,
  children,
  confirmLabel,
  cancelLabel,
  confirmColor = 'primary'
}: Props) => (
  <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle color="text.secondary" align="center" variant="h5">
      {title}
    </DialogTitle>

    {subtitle && (
      <DialogTitle
        color="text.secondary"
        align="center"
        variant="subtitle2"
        sx={{ pt: 0, mt: -2 }}
      >
        {subtitle}
      </DialogTitle>
    )}
    {children}
    <DialogActions sx={{ justifyContent: 'center' }}>
      <AppButton variant="outlined" sx={{ mr: '2.5%' }} onClick={onClose}>
        {cancelLabel ?? getTrans('general.cancel')}
      </AppButton>
      <AppButton color={confirmColor} sx={{ ml: '2.5%' }} onClick={onConfirm}>
        {confirmLabel ?? getTrans('general.confirm')}
      </AppButton>
    </DialogActions>
  </Dialog>
);
